<!-- BPMN overlay card shown below tasks linked to the focused application. -->
<!-- Displays the focused application name. -->
<template>
    <div v-if="applicationName" class="app-focus-annotation">
        <span class="app-focus-annotation__name">{{ applicationName }}</span>
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { isLinkedToTask } from "@/components/Applications/task-links";
import { focusedApplicationId } from "@/composables/bpmn-manager/application-focus";
import { useApplicationsManager } from "@/stores/applications-store";
import { useProcessElementsManager } from "@/stores/process-elements-store";

const props = defineProps<{
    elementId: string;
    processElementId?: string;
}>();

const { processElements } = useProcessElementsManager();
const { applications } = useApplicationsManager();

const processElement = computed(() =>
    processElements.value?.find(
        (p) =>
            p.identity === props.processElementId ||
            p.bpmn_id === props.elementId
    )
);

const applicationName = computed(() => {
    const taskId = processElement.value?.identity;
    if (!focusedApplicationId.value || !taskId) return null;
    return (
        applications.value.find(
            (a) =>
                a.identity === focusedApplicationId.value &&
                isLinkedToTask(a, taskId)
        )?.name ?? null
    );
});
</script>

<style scoped>
.app-focus-annotation {
    display: inline-flex;
    align-items: center;
    background: var(--stekz-applications-color);
    /* border: 1px solid var(--stekz-outline); */
    padding: 2px 6px;
    font-size: 10px;
    white-space: nowrap;
    pointer-events: none;
}

.app-focus-annotation__name {
    font-weight: 500;
    color: var(--stekz-on-surface);
}
</style>
